import React, {useState} from 'react';
import OtpInput from 'react-otp-input';
import {hasDataSelectorFn} from 'verticals/hotels-dweb/src/shared/pages/SRP/redux/selectors';
import Spinner from '../Spinner/Spinner';

import * as S from './OtpField.styles';

const OtpField = ({
  labelText,
  resendOtp,
  inputVal = '',
  numOfInput = 6,
  onChange,
  loader,
  handleResend,
  resendOtpLoader,
}) => {
  const [otp, setOtp] = useState('');

  const handleChange = opt => {
    setOtp(opt);
    onChange && onChange(opt);
  };

  const handleResendOtp = () => {
    handleResend && handleResend();
  };
  return (
    <S.Container>
      {labelText && <S.LabelText>{labelText}</S.LabelText>}
      <S.InputCont>
        <OtpInput value={otp} onChange={handleChange} numInputs={numOfInput} />
        {loader && <Spinner width="32px" height="32px" borderWidth="4px" />}
      </S.InputCont>
      {resendOtp && <S.Resend onClick={handleResendOtp}>{resendOtp}</S.Resend>}
      {resendOtpLoader && <Spinner width="12px" height="12px" borderWidth="4px" />}
    </S.Container>
  );
};

export default OtpField;
